module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/how-to-enjoy-sola-01-d521c8ae7c2cda5911f55d32961647bb.jpg";